import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../constants.js';
import { useCustomSIPHeaderForm } from '../hooks/useCustomSIPHeaderForm.js';

const CustomSIPHeaderSuffix = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { updateFormData } = useCustomSIPHeaderForm();

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[FORM_FIELD_PATHS.SUFFIX] &&
                touched[FORM_FIELD_PATHS.SUFFIX]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Suffix <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the suffix for the name of the header to be
                        presented.
                    </Text>
                </Box>
                <Field
                    component={NameField}
                    id={FORM_FIELD_PATHS.SUFFIX}
                    name={FORM_FIELD_PATHS.SUFFIX}
                    displayPrefix="X-TRE-C-"
                    maxLength={56}
                    onChange={(e) => {
                        updateFormData(
                            FORM_FIELD_PATHS.SUFFIX,
                            e.target.value.trim().toUpperCase(),
                        );
                    }}
                    validate={(value) => {
                        if (!value || value === '') {
                            return 'Suffix is required';
                        }
                        if (value.length > 56) {
                            return 'Suffix must be less than 56 characters';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the suffix for the header"
                        ariaLabel="custom-sip-header-suffix-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CustomSIPHeaderSuffix;
